import SEOLandingTemplate from './SEOLandingTemplate';

export default function WebsiteTrafficPage() {
  return (
    <SEOLandingTemplate
      title="Domain Overview Tool"
      metaTitle="Free Domain Overview Tool | Sungresh"
      metaDescription="Check a domain's authority score, organic traffic, ranking keywords, backlinks, and top competitors in one report."
      h1="Free Domain Overview Tool"
      sub="One report combining authority score, organic traffic estimates, ranking keywords, backlink counts, and top competing domains for any site."
      keywords="domain overview, domain overview tool, website overview, domain analysis tool"
      ctaLink="/domain/overview"
      ctaText="Analyze a Domain Free"
      features={[
        { icon: '⭐', title: 'Authority Score', desc: 'An overall domain strength estimate' },
        { icon: '📈', title: 'Organic Traffic', desc: 'Estimated organic search traffic and ranking keywords' },
        { icon: '🔗', title: 'Backlinks', desc: 'Backlink count and referring domains' },
        { icon: '🏆', title: 'Competitors', desc: 'Domains ranking for similar keywords' },
      ]}
      faqs={[
        { q: 'What can I actually do with this report?', a: 'It\'s a fast way to size up any domain before you invest more time — see roughly how much organic visibility they have, what keywords are driving it, and who else is competing for the same terms.' },
        { q: 'Where does the underlying data come from?', a: 'DataForSEO, a third-party SEO data provider. When live API credentials aren\'t configured on a given deployment, the tool clearly labels any fallback sample data instead of presenting it as real.' },
        { q: 'How should I use the competitor data?', a: 'Cross-reference it with the Keyword Gap and Backlink Gap tools to find specific keywords and linking domains a competitor has that you don\'t — a concrete starting list rather than a vague direction.' },
      ]}
    />
  );
}
